import ModuleDashboard from "@/components/modules/ModuleDashboard.vue";
import ModuleUsers from "@/components/modules/ModuleUsers.vue";
import EntityUser from "@/components/entities/EntityUser.vue";
import GeneralData from "@/components/general/GeneralData.vue";
import PdfSettings from "@/components/general/PdfSettings.vue";
import FinancialSettings from "@/components/general/FinancialSettings.vue";
import EmailSettings from "@/components/general/EmailSettings.vue";
import ModulePersons from "@/components/modules/ModulePersons.vue";
import EntityPerson from "@/components/entities/EntityPerson.vue";
import ModuleCompanies from "@/components/modules/ModuleCompanies.vue";
import EntityCompany from "@/components/entities/EntityCompany.vue";
import ModuleRegistrations from "@/components/modules/ModuleRegistrations.vue";
import EntityRegistration from "@/components/entities/EntityRegistration.vue";
import ModuleNotifications from "@/components/modules/ModuleNotifications.vue";
import EntityNotification from "@/components/entities/EntityNotification.vue";
import ModuleProducts from "@/components/modules/ModuleProducts.vue";
import ModuleMemberships from "@/components/modules/ModuleMemberships.vue";
import EntityMembership from "@/components/entities/EntityMembership.vue";
import ModulePackages from "@/components/modules/ModulePackages.vue";
import ModulePaymentPlans from "@/components/modules/ModulePaymentPlans.vue";
import EntityPaymentPlan from "@/components/entities/EntityPaymentPlan.vue";
import ModuleWares from "@/components/modules/ModuleWares.vue";
import ModuleSupplies from "@/components/modules/ModuleSupplies.vue";
import ModuleOffers from "@/components/modules/ModuleOffers.vue";
import EntityOffer from "@/components/entities/EntityOffer.vue";
import ModuleInvoices from "@/components/modules/ModuleInvoices.vue";
import EntityInvoice from "@/components/entities/EntityInvoice.vue";
import ModuleDailyReport from "@/components/modules/ModuleDailyReport.vue";
import StatisticsOverview from "@/components/modules/StatisticsOverview.vue";
import MembersStatistics from "@/components/modules/MembersStatistics.vue";
import FinancialStatistics from "@/components/modules/FinancialStatistics.vue";
import ModuleHelp from "@/components/modules/ModuleHelp.vue";
import ModuleMultiplePayments from "@/components/modules/ModuleMultiplePayments.vue";
import ModuleMessages from "@/components/modules/ModuleMessages.vue";
import EntityMessage from "@/components/entities/EntityMessage.vue";
import ModuleReceiptNotes from "@/components/modules/ModuleReceiptNotes.vue";
import EntityReceiptNote from "@/components/entities/EntityReceiptNote.vue";
import ModulePayments from "@/components/modules/ModulePayments.vue";
import ModuleIncomingInvoices from "@/components/modules/ModuleIncomingInvoices.vue";
import ModuleAssistance from "@/components/modules/ModuleAssistance.vue";
import ModuleGroups from "@/components/modules/ModuleGroups.vue";
import EntityGroup from "@/components/entities/EntityGroup.vue";
import ModuleRooms from "@/components/modules/ModuleRooms.vue";
import ModuleSessionTypes from "@/components/modules/ModuleSessionTypes.vue";
import EntitySession from "@/components/entities/EntitySession.vue";
import ModuleCalendar from "@/components/modules/ModuleCalendar.vue";
import SelfRegister from "@/components/general/SelfRegister.vue";
import WelcomeScreen from "@/components/general/WelcomeScreen.vue";
import AdditionalScreens from "@/components/general/AdditionalScreens.vue";
import MembersSettings from "@/components/general/MembersSettings.vue";
import WorkingHours from "@/components/general/WorkingHours.vue";
import ModuleIntisRegistrations from "@/components/modules/ModuleIntisRegistrations.vue";
import ModuleNukiRegistrations from "@/components/modules/ModuleNukiRegistrations.vue";

// Permission sets mirroring the menu item permissions. Enforced here as route guards
// (see main.js) and, authoritatively, by the permission middleware on the server.
const FINANCES = ['ADMINISTRATOR', 'FINANCES'];
const STATISTICS = ['ADMINISTRATOR', 'STATISTICS'];
const DAILY_REPORT = ['ADMINISTRATOR', 'STATISTICS', 'FINANCES'];
const NOTIFICATIONS = ['ADMINISTRATOR', 'NOTIFICATIONS'];
const ADMINISTRATOR = ['ADMINISTRATOR'];

export default [
    { path: '/self-register/:link', component: SelfRegister, meta: { public: true } },
    { path: '/welcome-screen/:link', component: WelcomeScreen, meta: { public: true } },
    { path: '/additional-screens', component: AdditionalScreens, meta: { permissions: ADMINISTRATOR } },
    { path: '/members-settings', component: MembersSettings, meta: { permissions: ADMINISTRATOR } },
    { path: '/', component: ModuleDashboard },
    { path: '/users', component: ModuleUsers,  meta: { transition: 'slide-left', permissions: ADMINISTRATOR } },
    { path: '/users/:id', component: EntityUser },
    { path: '/general-data', component: GeneralData, meta: { permissions: ADMINISTRATOR } },
    { path: '/pdf-settings', component: PdfSettings, meta: { permissions: ADMINISTRATOR } },
    { path: '/financial-settings', component: FinancialSettings, meta: { permissions: ADMINISTRATOR } },
    { path: '/email-settings', component: EmailSettings, meta: { permissions: ADMINISTRATOR } },
    { path: '/working-hours', component: WorkingHours, meta: { permissions: ADMINISTRATOR } },
    { path: '/intis-registrations', component: ModuleIntisRegistrations, meta: { permissions: ADMINISTRATOR } },
    { path: '/nuki-registrations', component: ModuleNukiRegistrations, meta: { permissions: ADMINISTRATOR } },
    { path: '/persons', component: ModulePersons },
    { path: '/persons/:id', component: EntityPerson },
    { path: '/companies', component: ModuleCompanies },
    { path: '/companies/:id', component: EntityCompany },
    { path: '/registrations', component: ModuleRegistrations },
    { path: '/registrations/:id', component: EntityRegistration },
    { path: '/notifications', component: ModuleNotifications, meta: { permissions: NOTIFICATIONS } },
    { path: '/notifications/:id', component: EntityNotification, meta: { permissions: NOTIFICATIONS } },
    { path: '/products', component: ModuleProducts },
    { path: '/memberships', component: ModuleMemberships },
    { path: '/memberships/:id', component: EntityMembership },
    { path: '/packages', component: ModulePackages },
    { path: '/supplies', component: ModuleSupplies, meta: { permissions: FINANCES } },
    { path: '/wares', component: ModuleWares, meta: { permissions: FINANCES } },
    { path: '/offers', component: ModuleOffers, meta: { permissions: FINANCES } },
    { path: '/offers/:id/:mode', component: EntityOffer, meta: { permissions: FINANCES } },
    { path: '/invoices', component: ModuleInvoices, meta: { permissions: FINANCES } },
    { path: '/invoices/:id/:mode', component: EntityInvoice, meta: { permissions: FINANCES } },
    { path: '/daily-report', component: ModuleDailyReport, meta: { permissions: DAILY_REPORT } },
    { path: '/statistics-overview', component: StatisticsOverview, meta: { permissions: STATISTICS } },
    { path: '/member-statistics', component: MembersStatistics, meta: { permissions: STATISTICS } },
    { path: '/financial-statistics', component: FinancialStatistics, meta: { permissions: STATISTICS } },
    { path: '/help', component: ModuleHelp},
    { path: '/multiple-payments', component: ModuleMultiplePayments, meta: { permissions: FINANCES } },
    { path: '/messages', component: ModuleMessages},
    { path: '/messages/:id', component: EntityMessage},
    { path: '/receipt-notes', component: ModuleReceiptNotes, meta: { permissions: FINANCES } },
    { path: '/receipt-notes/:id/:mode', component: EntityReceiptNote, meta: { permissions: FINANCES } },
    { path: '/payments', component: ModulePayments, meta: { permissions: FINANCES } },
    // clientFlag: the module is switched on per club from the dashboard, so the route is closed to a club
    // that does not have it - typing the address must not get anyone past a hidden menu entry.
    { path: '/payment-plans', component: ModulePaymentPlans, meta: { permissions: FINANCES, clientFlag: 'payment_plans_enabled' } },
    { path: '/payment-plans/:id', component: EntityPaymentPlan, meta: { permissions: FINANCES, clientFlag: 'payment_plans_enabled' } },
    { path: '/incoming-invoices', component: ModuleIncomingInvoices, meta: { permissions: FINANCES } },
    { path: '/groups', component: ModuleGroups },
    { path: '/groups/:id', component: EntityGroup },
    { path: '/rooms', component: ModuleRooms },
    { path: '/session-types', component: ModuleSessionTypes },
    { path: '/sessions/:id', component: EntitySession },
    { path: '/calendar', component: ModuleCalendar },
    { path: '/assistance', component: ModuleAssistance },
]